import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as _ from 'lodash';

import { minWidth, maxWidth } from './sidedrawer-config';


@Injectable()
export class SideDrawerService {

  public varName: string = 'sidedrawerData';
  public widthChange = new Subject<number>();

  private collapsed: boolean;
  private width: number;

  public setCollapsed(collapsed: boolean) {
    this.collapsed = collapsed;
    this.saveDataToLocalStorage();
  }

  public setWidth(width: number) {
    this.width = width;
    this.widthChange.next(this.width);
    this.saveDataToLocalStorage();
  }

  public getCollapsed(): boolean {
    if (_.isNil(this.collapsed)) {
      this.fetchData();
    }
    return this.collapsed;
  }

  public getWidth(): number {
    if (_.isNil(this.width)) {
      this.fetchData();
    }
    return this.width;
  }

  private saveDataToLocalStorage() {
    localStorage.setItem(this.varName, JSON.stringify({
      collapsed: this.collapsed,
      width: this.width,
    }));
  }

  private getDataFromLocalStorage(): any {
    const savedData: any = localStorage.getItem(this.varName);
    if (savedData) {
      return JSON.parse(savedData);
    } else {
      return null;
    }
  }

  private fetchData() {
    const savedData: any = this.getDataFromLocalStorage();
    if (savedData) {
      this.collapsed = savedData.collapsed;
      this.width = savedData.width;
    } else {
      this.setDefault();
    }
  }

  private setDefault() {
    this.setCollapsed(false);
    this.setWidth(maxWidth);
  }
}
